<script>
  /**
   * @type {number}
   */
  export let activeStep = 0

  /**
   * @type {{
   *   label: string
   * }[]}
   */
  export let steps = []

  const stepIndexHeightInPx = 24
</script>

<div class="stepper" style="--step-index-height: 24px">
  {#each steps as step, index}
    <div class="step">
      <span class="step-index-icon">
        <svg viewBox="0 0 {stepIndexHeightInPx} {stepIndexHeightInPx}" width="{stepIndexHeightInPx}px" style={`fill: ${activeStep === index ? "#1976d2": "#9e9e9e"}`}>
          <circle cx="{stepIndexHeightInPx / 2}" cy="{stepIndexHeightInPx / 2}" r="{stepIndexHeightInPx / 2}"></circle>
          <text x="{stepIndexHeightInPx / 2}" y="{stepIndexHeightInPx / 2}" text-anchor="middle" dominant-baseline="central" style="fill: white">{index + 1}</text>
        </svg>
      </span>
      {#if index !== 0}
        <span class="step-index-bridge"></span>
      {/if}
      <div class="label" class:active={activeStep === index}>
        {step.label}
      </div>
    </div>
  {/each}
</div>

<style>
  .stepper {
    display: flex;
    padding: 1rem 3rem;
  }
  .step {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
  }
  .step-index-bridge {
    border: 1px solid #bdbdbd;
    position: absolute;
    top: calc(var(--step-index-height) / 2);
    left: calc(-50% + 20px);
    right: calc(50% + 20px);
  }
  .label {
    font-size: .9rem;
    color: rgba(0, 0, 0, 0.6);
  }
  .active {
    font-weight: bold;
    color: black;
  }
</style>